import { useLocalStorage } from "react-use";
import { AppConfigContext } from "@/contexts";
import { NotificationMode } from "@/domains/app";

export const AppConfigProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [notificationMode, setNotificationMode] =
    useLocalStorage<NotificationMode>(
      "notificationMode",
      NotificationMode.Always
    );

  return (
    <AppConfigContext.Provider
      value={{ notificationMode: notificationMode!, setNotificationMode }}
    >
      {children}
    </AppConfigContext.Provider>
  );
};
